/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const LLMChatTypes = {

  INTERVIEW_CHAT: 'LLMChats::InterviewChat' as const,

  PARTICIPANT_SESSION_CHAT: 'LLMChats::ParticipantSessionChat' as const,

  PROJECT_CREATION_CHAT: 'LLMChats::ProjectCreationChat' as const,

  PROJECT_SESSIONS_CHAT: 'LLMChats::ProjectSessionsChat' as const,

  RECRUITMENT_CHAT: 'LLMChats::RecruitmentChat' as const,

  TWO_PANEL_WORKSPACE_PROJECT_CREATION_CHAT: 'LLMChats::TwoPanelWorkspaceProjectCreationChat' as const,

} as const;

export const LLMChatResourceTypes = {

  AI_MODERATED_INTERVIEW: 'AiModeratedInterview' as const,

  PROJECT_AVAILABILITY_RANGE: 'ProjectAvailabilityRange' as const,

  PROJECT: 'Project' as const,

} as const;
